export type CatalogItem = { variant: { id: string }; quantity: number }

export function buildItemsMap(
  items: CatalogItem[] = [],
): Map<string, CatalogItem> {
  return new Map(items.map((item) => [item.variant.id, item]))
}

export function diffNewItems(
  oldMap: Map<string, CatalogItem>,
  newMap: Map<string, CatalogItem>,
): {
  additions: CatalogItem[]
  updates: CatalogItem[]
  removals: CatalogItem[]
} {
  const additions: CatalogItem[] = []
  const updates: CatalogItem[] = []

  for (const [key, item] of newMap) {
    const oldItem = oldMap.get(key)
    if (!oldItem) {
      additions.push(item)
    } else if (oldItem.quantity !== item.quantity) {
      updates.push(item)
    }
  }

  const removals = Array.from(oldMap.values()).filter(
    (item) => !newMap.has(item.variant.id),
  )

  return { additions, updates, removals }
}
